'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".ThemedHistory-module_listItem__nryaY{margin:.75rem 0 0}";
var styles = {"listItem":"ThemedHistory-module_listItem__nryaY"};
styleInject["default"](css_248z, 'ddd0279c-a43d-4026-9269-b727b5c6d6b9');

exports["default"] = styles;
